import { HierarchicalMenu } from "react-instantsearch";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@repo/ui/components/ui/accordion";
import { cn } from "@repo/ui/lib/utils";

export default function AlgoliaHierarchicalMenu({
  attributes,
  title,
}: {
  attributes: string[];
  title: string;
}) {
  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="item-1">
        <div className="py-[16px]">
          <AccordionTrigger className="max-md:text-base font-medium py-0 data-[state=open]:text-primary-magenta">
            {title}
          </AccordionTrigger>
          <AccordionContent className="mt-[20px] pb-0">
            <HierarchicalMenu
              attributes={attributes}
              classNames={{
                root: "-ml-6",
                list: "ml-6 mt-2 flex flex-col",
                selectedItem: cn("relative"),
                link: cn(
                  "relative block",
                  "after:content-['+'] after:flex after:justify-center after:items-center after:h-[8px] after:w-[8px]",
                  "after:absolute after:top-[5px] after:right-[6px]",
                ),
                selectedItemLink: cn(
                  "font-bold pl-[12px]",
                  "after:content-['-']",
                  "[&_span]:before:!block",
                ),
                label: cn(
                  "relative",
                  "before:!hidden",
                  "before:absolute before:content-[''] before:flex before:justify-center before:items-center before:h-[8px] before:w-[8px]",
                  "before:rounded-full before:bg-primary-magenta before:absolute before:top-[5px] before:left-[-12px]",
                ),
                item: cn("py-3 w-[95%]"),
                count: "hidden",
              }}
            />
          </AccordionContent>
        </div>
      </AccordionItem>
    </Accordion>
  );
}
